import React from 'react';
import { Languages } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageContext';

const LanguageToggle = ({ className = '' }) => {
  const { locale, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className={`relative z-20 flex items-center justify-center w-10 h-10 rounded-full transition-all duration-200
        bg-white border border-gray-300 text-gray-500 shadow-sm
        hover:bg-gray-100 hover:shadow-md hover:text-gray-700 hover:border-gray-400
        focus:outline-none focus-visible:ring-0 ${className}`}
      title={locale === 'en' ? 'Switch to Spanish' : 'Cambiar a inglés'}
      aria-label={locale === 'en' ? 'Switch to Spanish' : 'Cambiar a inglés'}
    >
      <Languages className="w-4 h-4" />
    </button>
  );
};

export default LanguageToggle;
